import React from "react";
import { Link, useLocation } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

const LINKS = [
  { to: "/directory", label: "Directory", testid: "footer-link-directory" },
  { to: "/status", label: "Status", testid: "footer-link-status", superOnly: true },
  { to: "/reports", label: "Reports", testid: "footer-link-reports" },
  { to: "/?smart=1", label: "Smart AI Search", testid: "footer-link-smart-search" },
  { to: "/register", label: "Register", testid: "footer-link-register" },
  { to: "/admin", label: "Admin Console", testid: "footer-link-admin" },
  { to: "/privacy-policy", label: "Privacy Policy", testid: "footer-link-privacy" },
];

export default function Footer() {
  const loc = useLocation();
  const { user } = useAuth() || {};
  if (loc.pathname === "/" || loc.pathname === "/admin/login" || loc.pathname === "/admin/reset-password" || loc.pathname === "/portal" || loc.pathname === "/workman") return null;
  const visibleLinks = LINKS.filter((l) => !l.superOnly || user?.is_super);
  return (
    <footer className="mt-16 bg-ncc-navy text-white print:hidden">
      <div className="h-1.5 bg-gradient-to-r from-ncc-navy via-ncc-gold to-ncc-gold2" />
      <div className="mx-auto max-w-screen-2xl px-4 py-10 md:px-8">
        <div>
          <div className="industrial-label text-ncc-gold">Sections</div>
          <ul className="mt-4 grid grid-cols-2 gap-2 text-sm text-blue-100/90 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-7">
            {visibleLinks.map((l) => (
              <li key={l.to}>
                <Link to={l.to} data-testid={l.testid} className="transition-colors hover:text-ncc-gold">
                  {l.label}
                </Link>
              </li>
            ))}
          </ul>
        </div>
        <div className="mt-8 flex flex-col items-start justify-between gap-2 border-t border-white/15 pt-4 text-xs text-blue-100/70 md:flex-row">
          <div className="flex items-center gap-2">
            <span className="font-bold text-white">NCC Limited</span>
            <span>·</span>
            <span>Building India&apos;s Future</span>
          </div>
          <div className="industrial-label text-ncc-gold">Version 1.7.0</div>
        </div>
      </div>
    </footer>
  );
}
